// extracted by mini-css-extract-plugin
module.exports = {"container":"_1lxSyTHaZJFKHiVy7KclOd","restaurantsList":"_2Zqz0N8GXupxIMrASJYzTY"};